export const techNames = [
    "Amplify",
    "Angular",
    "CSharp",
    "Docker",
    "Git",
    "Java",
    "Python",
    "React",
    "Ruby",
    "Terraform",
    "Typescript", 
    "Vue",
    "Linux",
    "Lambda",
    "MySQL",
    "Firebase",
    "MongoDB",
    "PowerBI",
    "SQLServer",
    "PostgreSQL",
    "UiPath",
    "AWS",
    "Azure"

]

export const experienceNames = [
    "commercial",
    "educational",
    "personal"
]

export const projectNames = [
    "kibo",
    "aws",
    "honours",
    "permissions",
    "council",
    "location-database",
    "reborn"
]

export const footerIconNames = [
    "facebook",
    "linkedin",
    "github",
    "gmail"
]